import JSDB from '../../fromKotlin/nk';

const API_BASE = 'https://nihulkav.online:4000';
const S3_PUBLIC = 'https://nihulkav.s3.eu-south-1.amazonaws.com/data';

function companyCtx(): { company_id: string; company: string } {
    const user = JSDB().getUser().first;
    return {
        company_id: String(user?.company_id ?? ''),
        company: JSDB().getCompany(),
    };
}

/**
 * Upload a broadcast image to public S3 (same bucket as collage).
 * Returns the HTTPS URL Meta can fetch for an IMAGE template header.
 */
export async function uploadWhatsappBroadcastImage(file: File): Promise<string> {
    const ctx = companyCtx();
    const form = new FormData();
    form.append('company_id', ctx.company_id);
    form.append('company', ctx.company);
    form.append('image', file);
    const res = await fetch(`${API_BASE}/whatsapp/image/upload`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${JSDB().getToken()}` },
        body: form,
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json.status !== 'SUCCESS') {
        throw new Error(json?.status_msg || 'העלאת התמונה נכשלה');
    }
    const raw = json.status_msg ?? json.data;
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    const url = String(parsed?.url || '').trim();
    if (url.startsWith('https://') || url.startsWith('http://')) return url;
    const key = String(parsed?.key || '').trim();
    if (key) return `${S3_PUBLIC}/${key.replace(/^data\//, '')}`;
    throw new Error('לא התקבלה כתובת לתמונה');
}
